import Cookies from 'js-cookie';

/**
 * Returns A or B for A/B testing. Uses a single cookie shared across all
 * flows, so one visitor gets the same variant everywhere (searchflow,
 * vafflow, regflow, kftregflow) until the cookie expires.
 * Split: 50% A, 50% B.
 * @param {string} flowKey - e.g. 'searchflow', 'vafflow', 'regflow', 'kftregflow' (used only for logging)
 * @returns {'A'|'B'}
 */
const COOKIE_NAME = 'ab_version';
const COOKIE_DAYS = 30;
const B_RATIO = 0.5; // 50% B, 50% A

export function getOrPickVariant(flowKey) {
	const key = (flowKey && String(flowKey).toLowerCase()) || 'unknown';
	const cookieName = COOKIE_NAME;

	// Debug/testing: ?ab=B forces B, ?ab=A forces A, ?ab=reset clears cookie
	const urlParams = new URLSearchParams(window.location.search);
	const abParam = urlParams.get('ab');
	if (abParam === 'reset') {
		Cookies.remove(cookieName, { path: '/' });
		console.log('[A/B]', key, '- cookie cleared for', cookieName);
	}
	if (abParam === 'B' || abParam === 'A') {
		Cookies.set(cookieName, abParam, {
			expires: COOKIE_DAYS,
			path: '/',
			sameSite: 'Lax',
		});
		console.log('[A/B]', key, '- forced variant from URL:', abParam);
		return abParam;
	}

	const existing = Cookies.get(cookieName);
	if (existing === 'A' || existing === 'B') {
		console.log(
			'[A/B]',
			key,
			'- returning from cookie:',
			existing,
			'(cookie:',
			cookieName,
			')',
		);
		return existing;
	}
	const roll = Math.random();
	const variant = roll < B_RATIO ? 'B' : 'A';
	Cookies.set(cookieName, variant, {
		expires: COOKIE_DAYS,
		path: '/',
		sameSite: 'Lax',
	});
	console.log(
		'[A/B]',
		key,
		'- new random pick:',
		variant,
		'(no cookie, roll:',
		roll.toFixed(3),
		'<',
		B_RATIO,
		'= B)',
	);
	return variant;
}
